import { Divider, styled, Typography } from '@mui/material';
import { ReactElement } from 'react';

import { optionBorderColor } from './styled';

const SectionDividerLine = styled(Divider)(({ theme }) => ({
  '&::before, &::after': {
    borderColor: optionBorderColor(theme),
  },
}));

type Props = {
  label: string;
};

export const SectionDivider = ({ label }: Props): ReactElement => (
  <SectionDividerLine>
    <Typography fontSize={12} fontWeight={500} color="text.tertiary">
      {label}
    </Typography>
  </SectionDividerLine>
);
